import { UserRole } from "@it-tc/legacy-api";
import { useEffect, useState } from "react";
import { useLazyGetUserQuery } from "../../../../features/api/getUserApi";
import useIsLoggedIn from "./useIsLoggedIn";

export default useRole;

function useRole() {
  const [role, setRole] = useState<UserRole | null>(null);
  const isLoggedIn = useIsLoggedIn();
  const [getUserQuery] = useLazyGetUserQuery();
  useEffect(() => {
    if (isLoggedIn) {
      getUserQuery(undefined)
        .unwrap()
        .then(({ role }) => role)
        .then(setRole)
        .catch((reason: unknown) => {
          console.warn("Failed to get user's role:", reason);
        });
    }
  }, [isLoggedIn, getUserQuery]);
  return role;
}
